import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { processReq } from "../../helpers/processRequest";
import { GET, POST, PUT } from "../../utils/requestActionConstants";
import { API_ROUTE } from "../../utils/commonConstants";

const init = {
    order: {},
    orderList: [],
    loading: {},
    error: null
};

export const orderSlice = createSlice({
    name: "orderSlice",
    initialState: init,
    reducers: {
        setOrder: (state, action) => {
            state.order = action.payload;
        },

        setOrders: (state, action) => {
            state.orderList = action.payload;
        },

        setError: (state, action) => {
            state.error = action.payload;
        },

        clearData: (state) => {
            return init;
        },
    },
    extraReducers: (builder) => {
        builder
        // Fetch order list
        .addCase(fetchOrderList.pending, (state) => {
            state.loading.fetching = true;
            state.error = null;
        })
        .addCase(fetchOrderList.fulfilled, (state, action) => {
            state.loading.fetching = false;
            state.orderList = action.payload;
        })
        .addCase(fetchOrderList.rejected, (state, action) => {
            state.loading.fetching = false;
            state.error = action.payload;
        })

        // Add order
        .addCase(addOrder.pending, (state) => {
            state.loading.saving = true;
            state.error = null;
        })
        .addCase(addOrder.fulfilled, (state, action) => {
            state.loading.saving = false;
            state.order = action.payload;
        })
        .addCase(addOrder.rejected, (state, action) => {
            state.loading.saving = false;
            state.error = action.payload;
        })

        // Update order
        .addCase(updateOrder.pending, (state) => {
            state.loading.saving = true;
            state.error = null;
        })
        .addCase(updateOrder.fulfilled, (state, action) => {
            state.loading.saving = false;
            state.order = action.payload;
        })
        .addCase(updateOrder.rejected, (state, action) => {
            state.loading.saving = false;
            state.error = action.payload;
        });
    }
});

export const fetchOrderList = createAsyncThunk(
    "orderSlice/fetchOrderList",
    async (_, { rejectWithValue }) => {
        try {
            const response = await processReq(GET, `${API_ROUTE}/orders`);
            return response;
        } catch (error) {
            return rejectWithValue(error.toString() || "Failed to fetch order list");
        }
    }
);

export const updateOrder = createAsyncThunk(
    "orderSlice/updateOrder",
    async ({ orderId, orderData }, { rejectWithValue, dispatch }) => {
        try {
            const response = await processReq(PUT, `${API_ROUTE}/orders/${orderId}`, orderData);
            dispatch(fetchOrderList());

            return response.data;
        } catch (error) {
            return rejectWithValue(error.toString() || "Failed to update order");
        }
    }
);

export const addOrder = createAsyncThunk(
    "orderSlice/addOrder",
    async ({ orderData }, { rejectWithValue, dispatch }) => {
        try {
            const response = await processReq(POST, `${API_ROUTE}/orders/create`, orderData);
            dispatch(fetchOrderList());

            return response;
        } catch (error) {
            return rejectWithValue(error.toString() || "Failed to add order");
        }
    }
);

export const { clearData, setOrder, setOrders, setError } = orderSlice.actions;

export default orderSlice.reducer;
